import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { toBackgroundJobFetchError } from "./backgroundJob.utils";
import { BackgroundJobTags } from "./BackgroundJobTags";

/** Deletes a schedule (DELETE /background-job-schedules/{id}) and its EventBridge schedule; its past jobs stay. WRITE. */
export const deleteBackgroundJobScheduleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteBackgroundJobSchedule: builder.mutation<void, string>({
      queryFn: async (id) => {
        try {
          await axios.delete(
            `${backendBase()}/background-job-schedules/${encodeURIComponent(id)}`,
            { headers: { Accept: "application/json" } },
          );
          return { data: undefined };
        }
        catch (e) {
          return { error: toBackgroundJobFetchError(e) };
        }
      },
      invalidatesTags: [{ type: BackgroundJobTags.BackgroundJobSchedule, id: "LIST" }],
    }),
  }),
});

export const deleteBackgroundJobSchedule = deleteBackgroundJobScheduleApi.endpoints.deleteBackgroundJobSchedule;
